import SEO from "../../components/seo.jsx"
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AboutImg from "../../assets/dr-idris-MD.jpeg";
import DrIdris from "../../assets/team/Dr-idris.jpeg";

gsap.registerPlugin(ScrollTrigger);

const cinzel = { fontFamily: "'Cinzel', serif" };

const stats = [
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="34" height="34">
        <circle cx="32" cy="20" r="10" stroke="#c9a84c" strokeWidth="2.5" fill="none"/>
        <path d="M14 50c0-9.94 8.06-18 18-18s18 8.06 18 18" stroke="#c9a84c" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
        <circle cx="44" cy="38" r="5" stroke="#c9a84c" strokeWidth="2" fill="none"/>
        <path d="M44 35v3l2 2" stroke="#c9a84c" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="20" cy="38" r="5" stroke="#c9a84c" strokeWidth="2" fill="none"/>
        <path d="M18 40l2-2 2 2" stroke="#c9a84c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    value: "10,000+", label: "Happy Patients",
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="34" height="34">
        <rect x="12" y="18" width="40" height="30" rx="4" stroke="#c9a84c" strokeWidth="2.5" fill="none"/>
        <path d="M20 28h24M20 35h16" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round"/>
        <path d="M36 42l4-4 4 4" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28 18v-4M36 18v-4" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="44" cy="44" r="2" fill="#c9a84c"/>
      </svg>
    ),
    value: "1000+", label: "Testimonials",
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="34" height="34">
        <circle cx="32" cy="32" r="18" stroke="#c9a84c" strokeWidth="2.5" fill="none"/>
        <path d="M32 20v12l8 8" stroke="#c9a84c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M20 14l-4-4M44 14l4-4" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    value: "14+", label: "Years Experience",
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="34" height="34">
        <path d="M32 12l4 8 9 1.3-6.5 6.3 1.5 9L32 32l-8 4.6 1.5-9L19 21.3l9-1.3L32 12z" stroke="#c9a84c" strokeWidth="2.5" strokeLinejoin="round" fill="none"/>
        <path d="M20 46h24M24 50h16" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    value: "4", label: "Clinic Locations",
  },
];

const timeline = [
  { year: "2012", title: "Founded in Navi Mumbai",  desc: "Clinique Internationale was established in Navi Mumbai with a vision to provide advanced, affordable, and patient-focused hair restoration solutions." },
  { year: "2018", title: "Bangalore Center", desc: "Expanded to Bangalore, bringing advanced hair transplant and hair restoration treatments to patients across South India." },
  { year: "2020", title: "Pune Center", desc: "Opened our Pune center to make world-class hair restoration and aesthetic treatments more accessible across Maharashtra." },
  { year: "2023", title: "Shirdi Centre", desc: "Launched our Shirdi Centre, extending expert hair restoration services to patients from Shirdi and other interior areas of Maharastra." },
];

const certifications = [
  { 
  label: "AOMSI", 
  sub: "Association of Oral & Maxillofacial Surgeons of India" 
},
{ 
  label: "PACE Certified", 
  sub: "Patient Safety & Clinical Excellence Certification" 
},
{ 
  label: "Fellowship in Advanced Cosmetic Surgery", 
  sub: "Advanced Aesthetic & Cosmetic Surgical Training" 
},
];

const coreValues = [
  {
    title: "Core Values",
    desc: "Commitment & Consistency are the core values on which the members of our centre work religiously, in every consultation and every procedure we perform.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <path d="M16 12v40M16 12h26l-6 9 6 9H16" stroke="#c9a84c" strokeWidth="2.5" strokeLinejoin="round" fill="none"/>
      </svg>
    ),
  },
  {
    title: "Quality",
    desc: "Operative and follow-up care for every case is maintained and timely reviewed by us, to uphold the strict quality of cosmetic care delivered to our patients.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <path d="M22 14h20v8a10 10 0 01-20 0v-8z" stroke="#c9a84c" strokeWidth="2.5" fill="none"/>
        <path d="M22 16h-6a6 6 0 006 12M42 16h6a6 6 0 01-6 12" stroke="#c9a84c" strokeWidth="2" fill="none"/>
        <path d="M32 32v8M24 48h16M28 40h8v8h-8z" stroke="#c9a84c" strokeWidth="2" strokeLinejoin="round" fill="none"/>
      </svg>
    ),
  },
  {
    title: "Affordability",
    desc: "Clinique is a super-specialised hair restoration centre where every treatment related to hair is offered at a cost that's accessible to clients from all walks of life.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <circle cx="32" cy="32" r="20" stroke="#c9a84c" strokeWidth="2.5" fill="none"/>
        <path d="M26 24c0-3 2.7-5 6-5s6 2.3 6 5-2.7 4-6 5-6 2-6 5 2.7 5 6 5 6-2 6-5" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M32 16v4M32 44v4" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    title: "Expertise",
    desc: "Our team of surgeons works alongside the finest technicians to design, create and produce hair transplant results that we are consistently proud of.",
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <circle cx="32" cy="22" r="10" stroke="#c9a84c" strokeWidth="2.5" fill="none"/>
        <path d="M14 52c0-9.94 8.06-18 18-18s18 8.06 18 18" stroke="#c9a84c" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
      </svg>
    ),
  },
];

const locations = [ "Navi Mumbai (Kharghar)", "Bangalore", "Pune", "Shirdi"];

/* ─────────────────────────────────────────────
   COMPONENT
───────────────────────────────────────────── */
export default function AboutPageBangalore() {
  const pageRef         = useRef(null);
  const heroEyebrowRef   = useRef(null);
  const heroHeadingRef   = useRef(null);
  const heroSubRef       = useRef(null);
  const storyEyebrowRef  = useRef(null);
  const storyHeadingRef  = useRef(null);
  const storyBodyRef     = useRef(null);
  const storyBody2Ref    = useRef(null);
  const locRowRef        = useRef(null);
  const statsRowRef      = useRef(null);
  const statItemsRef     = useRef([]);
  const valueItemsRef    = useRef([]);
  const valueRowRef      = useRef(null);
  const founderRef       = useRef(null);
  const reviewCardRef    = useRef(null);
  const certRowRef       = useRef(null);
  const certItemsRef     = useRef([]);
  const timelineRef      = useRef(null);
  const timelineItems    = useRef([]);
  const missionRef       = useRef(null);
  const ctaRef           = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";

      const fadeUp = (el, trigger, delay = 0) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, y: 32 },
          { opacity: 1, y: 0, duration: 0.75, ease, delay,
            scrollTrigger: { trigger: trigger || el, start: "top 88%", toggleActions: "play none none reverse" } }
        );
      };

      fadeUp(heroEyebrowRef.current);
      fadeUp(heroHeadingRef.current, null, 0.08);
      fadeUp(heroSubRef.current, null, 0.14);

      fadeUp(storyEyebrowRef.current);
      fadeUp(storyHeadingRef.current, null, 0.06);
      fadeUp(storyBodyRef.current, null, 0.12);
      fadeUp(storyBody2Ref.current, null, 0.18);
      fadeUp(locRowRef.current, null, 0.22);

      statItemsRef.current.forEach((el, i) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, y: 48, rotateX: 18 },
          { opacity: 1, y: 0, rotateX: 0, duration: 0.7, ease, delay: i * 0.1,
            scrollTrigger: { trigger: statsRowRef.current, start: "top 88%", toggleActions: "play none none reverse" } }
        );
      });

      valueItemsRef.current.forEach((el, i) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, y: 30 },
          { opacity: 1, y: 0, duration: 0.65, ease, delay: i * 0.08,
            scrollTrigger: { trigger: valueRowRef.current, start: "top 88%", toggleActions: "play none none reverse" } }
        );
      });

      fadeUp(founderRef.current);
      fadeUp(reviewCardRef.current, null, 0.1);

      certItemsRef.current.forEach((el, i) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, y: 24, scale: 0.96 },
          { opacity: 1, y: 0, scale: 1, duration: 0.6, ease, delay: i * 0.08,
            scrollTrigger: { trigger: certRowRef.current, start: "top 88%", toggleActions: "play none none reverse" } }
        );
      });

      timelineItems.current.forEach((el, i) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, x: i % 2 === 0 ? -40 : 40 },
          { opacity: 1, x: 0, duration: 0.7, ease, delay: i * 0.1,
            scrollTrigger: { trigger: timelineRef.current, start: "top 85%", toggleActions: "play none none reverse" } }
        );
      });

      fadeUp(missionRef.current);
      fadeUp(ctaRef.current);

    }, pageRef);
    return () => ctx.revert();
  }, []);

  return (
    <>
    <SEO
  title="About Clinique Internationale Bangalore | Dr. Idris"
  description="Learn about Clinique Internationale's Bangalore Division, led by Dr. Idris — our story, core values, certifications, and journey in hair restoration."
  url="https://bangalore.hairclinique.in/description.php"
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

<style>
  {`/* ── CERTIFICATIONS ── */
.ab__cert-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px; /* was 12px */
}

.ab__cert-item {
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(201,168,76,0.14);
  border-radius: 8px; /* was 10px */
  padding: 10px 12px; /* was 16px 18px */
  display: flex;
  align-items: center;
  gap: 8px; /* was 12px */
  transition: background 0.2s, border-color 0.2s;
}

.ab__cert-item:hover {
  background: rgba(201,168,76,0.07);
  border-color: rgba(201,168,76,0.28);
}

.ab__cert-dot {
  width: 6px; /* was 8px */
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--gold), var(--gold-lt));
  flex-shrink: 0;
}

.ab__cert-label {
  font-family: 'Cinzel', serif;
  font-size: 9px; /* was 10.5px */
  font-weight: 700;
  letter-spacing: 0.08em;
  color: rgba(255,255,255,0.85);
  line-height: 1.2;
}

.ab__cert-sub {
  font-size: 9px; /* was 10.5px */
  color: rgba(255,255,255,0.4);
  margin-top: 1px;
  line-height: 1.2;
}`}
</style>

      <div ref={pageRef} className="relative mt-16 sm:mt-20 lg:mt-30 w-full bg-[#f2ece0] overflow-hidden font-['Raleway',sans-serif]">
        {/* ═══════════════════ HERO BANNER ═══════════════════ */}
<div className="relative h-[150px] sm:h-[360px] md:h-[600px] flex items-end sm:items-center justify-end overflow-hidden">
  <img
    className="absolute inset-0 w-full h-full object-cover"
    src={AboutImg}
    alt="Clinique Internationale hair restoration clinic"
  />
  {/* Real gradient overlay so text is legible on mobile */}
  <div className="absolute inset-0" />
</div>

        {/* ═══════════════════ OUR STORY ═══════════════════ */}
        <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12">
          <div className="pt-16 sm:pt-20 md:pt-24 text-center">
            <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#a07828] mb-3 flex items-center justify-center gap-2.5">
              <span className="w-6 h-px bg-[#c9a84c]" />
              Our Story
            </p>
            <h2
              ref={storyHeadingRef}
              style={cinzel}
              className="font-black text-[1.5rem] sm:text-[1.8rem] md:text-[2.1rem] tracking-[0.04em] uppercase text-[#1a0f02] mb-6"
            >
              Restoring Confidence, One Patient at a Time
            </h2>
            <p ref={storyBodyRef} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto mb-4">
              Clinique is a super-specialised Hair Restoration Centre where each and every treatment
              related to hair is done at an affordable cost. This project is initiated by our Founder,{" "}
              <strong className="font-semibold">Dr. Idris</strong>, who is known in the field
              of Hair Restoration. Clinique Internationale's first centre was in Mumbai, established
              in early 2012.
            </p>
            <p ref={storyBody2Ref} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto mb-4">
              Our centre caters to clients from all walks of life. Over the years, patient reviews,
              client logos, case studies and results have brought consistency to our work. Our team
              of surgeons work with the finest technicians to design, create and produce hair
              transplant results that we are proud of.
            </p>

            <div ref={locRowRef} className="flex flex-wrap items-center justify-center gap-3 mt-7">
              {locations.map((loc) => (
                <span
                  key={loc}
                  style={cinzel}
                  className="text-[10px] sm:text-[10.5px] font-bold tracking-[0.08em] uppercase text-[#a07828] border border-[#c9a84c]/35 rounded-full px-4 sm:px-5 py-2 bg-[#c9a84c]/[0.06]"
                >
                  {loc}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* ═══════════════════ STATS ═══════════════════ */}
        <div className="px-5 sm:px-6 md:px-8 lg:px-12 mt-16">
          <div ref={statsRowRef} className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 md:gap-5">
            {stats.map((s, i) => (
              <div
                key={i}
                ref={(el) => (statItemsRef.current[i] = el)}
                className="flex flex-col items-center justify-center text-center gap-3 bg-white rounded-2xl border border-[#c9a84c]/20 px-4 sm:px-5 py-7 sm:py-9
                           shadow-[0_2px_4px_rgba(90,60,10,0.05),0_8px_24px_rgba(90,60,10,0.08),0_24px_48px_rgba(90,60,10,0.06)]
                           hover:-translate-y-1.5 transition-transform duration-300 relative overflow-hidden"
              >
                <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/55 to-transparent" />
                <div className="w-14 sm:w-[68px] h-14 sm:h-[68px] rounded-full bg-gradient-to-br from-[#c9a84c]/10 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center">
                  {s.icon}
                </div>
                <div>
                  <p style={cinzel} className="font-black text-[1.55rem] sm:text-[1.9rem] leading-none mb-1 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">
                    {s.value}
                  </p>
                  <p className="text-[11.5px] sm:text-[12.5px] font-medium tracking-wide text-[#6b5535] leading-snug">
                    {s.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ═══════════════════ CORE VALUES ═══════════════════ */}
        <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12">
          <div className="py-16 sm:py-20 md:py-24">
            <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#a07828] mb-3 flex items-center justify-center gap-2.5">
              <span className="w-6 h-px bg-[#c9a84c]" />
              What Drives Us
            </p>
            <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.8rem] text-center text-[#1a0f02] uppercase tracking-[0.06em] mb-10 sm:mb-12">
              Our Core Values
            </h3>
            <div ref={valueRowRef} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5 sm:gap-6">
              {coreValues.map((v, i) => (
                <div
                  key={i}
                  ref={(el) => (valueItemsRef.current[i] = el)}
                  className="bg-white border border-[#c9a84c]/[0.18] rounded-2xl p-6 sm:p-7 text-left hover:-translate-y-1.5 hover:shadow-[0_16px_36px_rgba(90,60,10,0.1)] transition-all duration-300"
                >
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#c9a84c]/10 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center mb-4">
                    {v.icon}
                  </div>
                  <div style={cinzel} className="text-[14px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-2.5">
                    {v.title}
                  </div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ═══════════════════ FOUNDER + REVIEWS + CERTS ═══════════════════ */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/35 to-transparent" />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start">

            <div ref={founderRef}>
              <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#c9a84c]/70 mb-3 flex items-center gap-2.5">
                <span className="w-6 h-px bg-[#c9a84c]/50" />
                Lead Surgeon &amp; Director
              </p>
              <div className="relative overflow-hidden bg-gradient-to-br from-[#c9a84c]/[0.08] to-[#c9a84c]/[0.02] border border-[#c9a84c]/[0.18] rounded-2xl p-7 sm:p-8">
                <span className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent" />
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-[110px] sm:w-[140px] h-[110px] sm:h-[140px] rounded-full border-2 border-[#c9a84c]/55 flex-shrink-0 overflow-hidden shadow-[0_0_0_4px_rgba(201,168,76,0.12),0_8px_24px_rgba(0,0,0,0.45)]">
                    <img src={DrIdris} alt="Dr. Idris — Lead Surgeon, Bangalore Division" className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <div style={cinzel} className="text-[15px] sm:text-[16px] font-bold text-white/90 tracking-[0.06em] mb-1">
                      Dr. Idris
                    </div>
                    <div className="text-[12px] text-[#c9a84c]/85 tracking-wide">
                      Facial Cosmetic &amp; Hair Transplant Surgeon
                    </div>
                  </div>
                </div>
                <p className="text-[13.5px] leading-[1.8] text-white/60">
                  Dr. Idris is a facial cosmetic and hair transplant surgeon with a global reputation for
                  excellence, and is the Director of Clinique Internationale's Bangalore Division. He is
                  also a Consultant Surgeon at GM-Apollo Hospital and the 32 Smiles chain in Bangalore.
                  He has successfully performed hair transplant surgery for thousands of patients,
                  including hundreds of dentists and doctors from around the world, carrying out each
                  procedure himself with a deeply patient-centred philosophy.
                </p>
                <div className="flex flex-wrap gap-2 mt-5">
                  {["FUE", "FUT", "GM-Apollo Hospital", "32 Smiles Chain"].map((t) => (
                    <span
                      key={t}
                      style={cinzel}
                      className="text-[9.5px] tracking-[0.12em] uppercase text-[#c9a84c]/90 border border-[#c9a84c]/25 rounded px-2.5 py-1"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div ref={reviewCardRef}>
              <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#c9a84c]/70 mb-3 flex items-center gap-2.5">
                <span className="w-6 h-px bg-[#c9a84c]/50" />
                Patient Trust
              </p>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-7">
                <div className="flex items-center gap-3 mb-4">
                  <svg className="w-8 h-8 flex-shrink-0" viewBox="0 0 48 48">
                    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.3 9 3.4l6.7-6.7C35.8 2.6 30.2 0 24 0 14.8 0 6.9 5.4 3 13.3l7.8 6C12.5 13.5 17.8 9.5 24 9.5z"/>
                    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4 7.1-10 7.1-17z"/>
                    <path fill="#FBBC05" d="M10.8 28.7A14.8 14.8 0 019.5 24c0-1.6.3-3.2.8-4.7L2.5 13.3A23.8 23.8 0 000 24c0 3.8.9 7.4 2.5 10.7l8.3-6z"/>
                    <path fill="#34A853" d="M24 48c6.2 0 11.5-2 15.3-5.5l-7.5-5.8c-2.1 1.4-4.7 2.3-7.8 2.3-6.2 0-11.5-4-13.4-9.5l-7.8 6C6.9 42.6 14.8 48 24 48z"/>
                  </svg>
                  <div>
                    <div style={cinzel} className="text-[22px] font-black text-white">4.9</div>
                    <div className="text-[#fbbc04] text-sm tracking-[2px]">★★★★★</div>
                    <div className="text-xs text-white/45 mt-0.5">Based on 1,000+ Google Reviews</div>
                  </div>
                </div>
                <p className="text-[13px] italic leading-[1.75] text-white/60 border-l-2 border-[#c9a84c]/40 pl-3.5">
                  "From the first consultation to the final result, the whole process felt personal and
                  unrushed. Dr Idris explained every step, carried out the surgery himself, and the
                  hairline looks completely natural. We would definitely recommend everyone to visit this
                  place to address all your hair related issues."
                </p>
                <p className="text-[11.5px] text-[#c9a84c]/80 mt-3 font-medium">— Patient, Bangalore · Verified Patient</p>
              </div>

                            {/* Certifications */}
              <div style={{ marginTop: "28px" }}>
                <p style={{ fontFamily:"'Cinzel',serif", fontSize:"10px", letterSpacing:"0.22em", textTransform:"uppercase", color:"rgba(255,255,255,0.4)", marginBottom:"14px" }}>
                  Certifications &amp; Accreditations
                </p>
                <div ref={certRowRef} className="ab__cert-row">
                  {certifications.map((c, i) => (
                    <div key={i} ref={el => certItemsRef.current[i] = el} className="ab__cert-item">
                      <span className="ab__cert-dot" />
                      <div>
                        <div className="ab__cert-label">{c.label}</div>
                        <div className="ab__cert-sub">{c.sub}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ═══════════════════ TIMELINE ═══════════════════ */}
        <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12">
          <div className="py-16 sm:py-20 md:py-24">
            <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#a07828] mb-3 flex items-center justify-center gap-2.5">
              <span className="w-6 h-px bg-[#c9a84c]" />
              Our Journey
            </p>
            <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.8rem] text-center text-[#1a0f02] uppercase tracking-[0.06em] mb-12 sm:mb-14">
              Two Decades of Excellence
            </h3>
            <div ref={timelineRef} className="relative grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-0">
              <span className="hidden md:block absolute top-[40px] left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 via-[#c9a84c]/40 to-transparent z-0" />
              {timeline.map((t, i) => (
                <div
                  key={i}
                  ref={(el) => (timelineItems.current[i] = el)}
                  className="flex flex-col items-center text-center px-4 relative z-10"
                >
                  <div className="relative w-[18px] h-[18px] rounded-full bg-[#f2ece0] border-2 border-[#c9a84c] shadow-[0_0_0_5px_rgba(201,168,76,0.12)] mb-5 flex-shrink-0">
                    <span className="absolute inset-[3px] rounded-full bg-[#c9a84c]" />
                  </div>
                  <div style={cinzel} className="text-[13px] font-bold tracking-[0.1em] text-[#c9a84c] mb-2">{t.year}</div>
                  <div style={cinzel} className="text-[17px] font-bold text-[#1a0f02] mb-2 tracking-[0.04em]">{t.title}</div>
                  <p className="text-[14px] leading-[1.7] text-[#6b5535]">{t.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ═══════════════════ MISSION ═══════════════════ */}
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12">
            <div ref={missionRef} className="max-w-3xl mx-auto text-center">
              <p style={cinzel} className="text-[1.1rem] sm:text-[1.3rem] md:text-[1.5rem] font-normal leading-[1.65] text-white/90 tracking-[0.03em]">
                Our mission is to make{" "}
                <em className="italic" style={{ color: "#c9a84c" }}>
                  world-class hair restoration
                </em>{" "}
                accessible to every patient — delivered with surgical precision, honest counsel and
                care that lasts well beyond the procedure.
              </p>
              <p className="text-[11.5px] tracking-[0.18em] uppercase text-[#c9a84c]/55 mt-6">
                — Dr. Idris, Bangalore Division
              </p>
            </div>
          </div>
        </div>

        {/* ═══════════════════ CTA ═══════════════════ */}
        <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12">
          <div className="py-16 sm:py-20 md:py-24">
            <div ref={ctaRef} className="max-w-xl mx-auto text-center">
              <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.9rem] text-[#1a0f02] uppercase tracking-[0.06em] mb-3.5">
                Begin Your Restoration Journey
              </h3>
              <p className="text-[14px] text-[#6b5535] leading-[1.75] mb-8">
                Book a one-on-one consultation with our specialists at any of our 4 centres
                across India and take the first step toward lasting results.
              </p>
              <div className="flex items-center justify-center gap-4 flex-wrap">
                <a
                  href="/bangalore.php"
                  style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
                  className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] cursor-pointer transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] inline-block hover:bg-right"
                >
                  Book Consultation
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}